export const company = {
  name: '2xHappiness',
  contactEmail: 'yuw558071@gmail.com',
  values: [
    'Small apps with a clear purpose',
    'Useful tools for everyday moments',
    'Simple design without extra noise',
    'A little more sweetness in the day',
  ],
};
